
























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import UsersApi from "@/services/UsersApi";
import TooltipModule from "@/store/tooltip";
import AuthModule from "@/store/auth";
import axios, { AxiosResponse } from "axios";
import CTooltip from "@/components/CTooltip.vue";
import dayjs from "dayjs";
import { ZipAddressResponse } from "@/types";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class RegisterForm extends Vue {
  // 郵便番号
  private postcode = "";

  // 入力フォーム
  private form = {
    name: "",
    password: "",
    confirmPassword: "",
    ugcUuid: undefined,
    detail: {
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  // 入力、表示の日付
  private inputDate = "";

  // v-menu
  private menu = false;

  // v-date-picker
  private activePicker: string | null = null;

  // エラーモーダルの表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async mounted() {
    this.tokenCheck();
  }

  private tokenCheck() {
    // 本登録トークン取得
    const { token } = this.$route.query;
    if (!token) {
      // tokenがない場合はUPreRegisterに戻る
      this.$router.push({ name: "UPreRegister" });
    }
  }

  //  date-pickerをchangeした時に実行
  private changeDatePicker(date: Date) {
    this.inputDate = dayjs(date).format("YYYYMMDD");
    // changeした後、カレンダーを非表示（閉じる）
    this.menu = false;
  }

  // 誕生日を変更するごとに以下を実行(カレンダーアイコンをクリックした時)
  @Watch("menu")
  private async clickCalendar() {
    // 一定の処理を終えたら
    setTimeout(() => {
      // 年のみの表示
      this.activePicker = "YEAR";
    });
  }

  // axioを利用して郵便番号から住所の特定
  @Watch("postcode")
  private async autoCompleteAddress() {
    await axios
      .get(`https://api.zipaddress.net/?zipcode=${this.postcode}`)
      .then((response: AxiosResponse<ZipAddressResponse>) => {
        this.form.detail.prefecture = response.data.data.pref;
        this.form.detail.city = response.data.data.city;
      })
      .catch(() => {
        this.form.detail.prefecture = "";
        this.form.detail.city = "";
      });
  }

  // 入力完了が押されたとき
  private async submit() {
    // 日付変換
    if (this.form.detail) {
      this.form.detail.birthday = dayjs(this.inputDate).format("YYYY-MM-DD");
    }
    // 本登録トークン取得
    const { token } = this.$route.query;
    const UsersRes = UsersApi.createInstance(token as string);
    try {
      const UserRes = await UsersRes.createUser(this.form);
      if (!UserRes?.data?.data?.user) {
        return;
      }
      AuthModule.commitMe(UserRes.data.data.user);
      // URegisterCompに進む
      this.$router.push({ name: "URegisterComp" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      await setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
